import { useMemo } from "react";
import { RgModal } from "./RgModal";
import { BREAKFAST_ITEMS, BAINFLEURS_ITEMS, DECOR_ITEMS, moduleProgress } from "./rgModules";
import { parseBreakfastForm } from "./rgBreakfastParser";

/**
 * ModuleModal — équivalent web du ModuleScreen mobile (741 lignes).
 * Affiche les items d'un module (petit-déj / bain de fleurs / décor)
 * avec toggle 3-états : stock (vert) · à acheter (rouge) · non défini.
 */

const TITLES = {
  petit_dej: "🥐 Petit-déjeuner",
  bain_fleurs: "🌸 Bain de fleurs",
  decor: "🌹 Décor du refuge",
};

export default function ModuleModal({ open, onClose, moduleKey, reservation, onUpdateReservation }) {
  const state = reservation?.module_states?.[moduleKey] || {};
  const parsedNote = useMemo(() => parseBreakfastForm(reservation?.notes), [reservation?.notes]);
  const form = {
    voyageurs: parsedNote.voyageurs,
    confitures: parsedNote.confitures,
    beurre_type: (parsedNote.beurre || "").toLowerCase().includes("thym") ? "thym" : "nature",
  };
  const decorType = reservation?.decor_type;

  const items = moduleKey === "petit_dej" ? BREAKFAST_ITEMS
              : moduleKey === "bain_fleurs" ? BAINFLEURS_ITEMS
              : DECOR_ITEMS;
  const visible = items.filter((it) => !it.visible || it.visible(form, decorType));
  const prog = moduleProgress(reservation || { module_states: state }, moduleKey);

  const setState = (itemKey, newState) => {
    const nextStates = { ...(reservation.module_states || {}) };
    const cur = { ...(nextStates[moduleKey] || {}) };
    if (newState === null) delete cur[itemKey]; else cur[itemKey] = newState;
    nextStates[moduleKey] = cur;
    onUpdateReservation({ module_states: nextStates });
  };

  return (
    <RgModal open={open} onClose={onClose} title={TITLES[moduleKey]} testid={`rg-module-modal-${moduleKey}`}>
      <p style={{ margin: "0 0 12px", color: "#6B6E6C", fontSize: 13 }}>
        Progression : {prog.done}/{prog.total} items décidés
      </p>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {visible.map((it) => {
          const s = state[it.key];
          const isBuy = s === "buy";
          const isStock = s === "stock";
          return (
            <li key={it.key} style={{
              display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
              background: "#fff", border: "1px solid #EAE7E1", borderRadius: 10, marginBottom: 6,
            }}>
              <span style={{ fontSize: 20, width: 28, textAlign: "center" }}>{it.icon}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{it.label}</div>
                {it.hint && <div style={{ fontSize: 11, color: "#9A9C99", fontStyle: "italic" }}>{it.hint}</div>}
                {it.ingredients && (
                  <div style={{ fontSize: 11, color: "#6B6E6C", marginTop: 4 }}>
                    Ingrédients : {it.ingredients.join(" · ")}
                  </div>
                )}
              </div>
              <div style={{ display: "flex", gap: 4 }}>
                <button
                  onClick={() => setState(it.key, isStock ? null : "stock")}
                  data-testid={`rg-mod-${moduleKey}-${it.key}-stock`}
                  style={{
                    padding: "4px 10px", borderRadius: 999,
                    background: isStock ? "#507561" : "transparent",
                    color: isStock ? "#fff" : "#507561",
                    border: `1px solid #507561`, cursor: "pointer", fontSize: 11, fontWeight: 500,
                  }}
                >Stock</button>
                <button
                  onClick={() => setState(it.key, isBuy ? null : "buy")}
                  data-testid={`rg-mod-${moduleKey}-${it.key}-buy`}
                  style={{
                    padding: "4px 10px", borderRadius: 999,
                    background: isBuy ? "#C27A62" : "transparent",
                    color: isBuy ? "#fff" : "#C27A62",
                    border: `1px solid #C27A62`, cursor: "pointer", fontSize: 11, fontWeight: 500,
                  }}
                >Acheter</button>
              </div>
            </li>
          );
        })}
      </ul>
    </RgModal>
  );
}
